	export interface ISize {
		width: number;
		height: number;
	}

	export interface IPosition {
		top: number,
		left: number
	}

	export interface IBounds extends ISize, IPosition {

	}

	export interface IPoint2D {
		x: number;
		y: number;
	}

	export class Bounds implements IBounds {
		public width = 0;
		public height = 0;
		public top = 0;
		public left = 0;

		public constructor(width: number = 0, height: number = 0, top: number = 0, left: number = 0){
			this.width = width;
			this.height = height;
			this.top = top;
			this.left = left;
		}

	}
